export default "__VITE_ASSET__0a881bb7__"